import {event} from '../modules/event';
import {ajax} from '../modules/ajax';
import {SearchPopup} from '../modules/SearchPopup';

class SearchMain {
	constructor(btn){
		this._createElements(btn);
		this._addEvents();
	}

	_createElements(btn){
		this.btn = btn;
        this.popup = false;
	}

	_addEvents(){
		var self = this;

		event.add(this.btn, 'click', function(e){
            e.preventDefault();
			self._showPopup.call(self);
		});
	}

    _showPopup(){
        var src = '/static/',
            self = this,
            inner=
                '<div class=grid>' +
                    '<div class=grid_row>' +
                        '<div class="grid_cell10 grid_offset2">' +
                            '<span class="title5 top20">Поиск</span>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="layer bottom20 layer-reverse top10">' +
                    '<div class=grid>' +
                        '<div class=grid_row>' +
                            '<div class="grid_cell10 grid_offset2">' +
                                '<form autocomplete=off class="searchForm searchForm-large searchForm-popup" data-SearchPopup-form method="get" action="'+ this.btn.href +'">' +
                                    '<input class=searchForm_field data-SearchPopup-field type="text" name="q"> ' +
                                    '<svg class=searchForm_icon role=img><use xlink:href='+ src +'img/symbols/sprite.svg#loupe></use></svg>' +
                                    '<input class=searchForm_btn type=submit value=ok>' +
                                '</form>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="layer layer-content">' +
                    '<div class="grid grid-popupSearch"data-SearchPopup-box></div>' +
                '</div>';

        uPopup.closeAll();
        this.popup = uPopup({
            addClass:'popup-search',
            name:'search-main',
            content:inner,
            onopen:function(){

            }
        });

        new SearchPopup(self.popup.table);

    }
};

export {SearchMain};